import { takeEvery } from 'redux-saga/effects';

// internal
import * as ActionType from '@app/store/typings/actions/project.d';
import {
  fetchData,
  fetchWithId,
  selectId,
  createProject,
  updateProject,
  deleteProject,
  uploadProjectPicture,
} from '@app/store/sagas/project/data';
import {
  RoleInProjectWithId,
  listRolesInProject,
  createRoleInProject,
  updateRoleInProject,
  deleteRolesInProject,
} from '@app/store/sagas/project/role';

export function* projectSaga() {
  yield takeEvery(ActionType.KEY_PROJECT_FETCH, fetchData);
  yield takeEvery(ActionType.KEY_PROJECT_FETCH_WITHID, fetchWithId);
  yield takeEvery(ActionType.KEY_PROJECT_CREATE, createProject);
  yield takeEvery(ActionType.KEY_PROJECT_UPDATE, updateProject);
  yield takeEvery(ActionType.KEY_PROJECT_DELETE, deleteProject);
  yield takeEvery(ActionType.KEY_PROJECT_SELECT_ID, selectId);
  yield takeEvery(ActionType.KEY_PROJECT_ROLE_WITHID, RoleInProjectWithId);
  yield takeEvery(ActionType.KEY_PROJECT_LISTROLES, listRolesInProject);
  yield takeEvery(ActionType.KEY_PROJECT_CREATE_ROLE, createRoleInProject);
  yield takeEvery(ActionType.KEY_PROJECT_UPDATE_ROLE, updateRoleInProject);
  yield takeEvery(ActionType.KEY_PROJECT_DELETE_ROLES, deleteRolesInProject);
  yield takeEvery(ActionType.KEY_PROJECT_UPLOAD_PICTURE, uploadProjectPicture);
}
